import React from 'react';

const Paragraph = (props) => {
    return (
        <p>{props.text}</p>
    );
};

export default Paragraph;